﻿import React, { useState, useEffect } from 'react';
import GlobalDialog from '../Modal/GlobalDialog';
import GcMethodDetailsComponent from './GcMethodDetailsComponent';
import HplcMethodDetailsComponent from './HplcMethodDetailsComponent';
import QnmrMethodDetailsComponent from './QnmrMethodDetailsComponent';
import SearchMethodsComponent from './SearchMethodsComponent';
import NoteViewer from '../NoteViewer';
import { MethodSearch } from '../../models/Methods/method-search';
import { MethodProduct } from '../../models/Methods/method-product';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType, NoteType, BenchSheetTechnologyType, MethodState, DocumentType } from '../../models/enums';
import { ItemBasicInformation } from '../../models/item-basic-information';
import { Technology } from '../../models/technology';
import DocumentLoader from '../DocumentLoader';
import { Method } from '../../models/Methods/method';
import { ToastProps } from '../../models/toast-props';
import { FieldUpdate } from '../../models/field-update';
import { CrudFunctions } from '../../utilities/crud-functions';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import DmaFooter from '../DmaFooter';

import DataGrid, {
    Column,
    FilterRow,
    Selection,
    Button as ColumnButton,
    HeaderFilter,
    Toolbar,
    Item as ToolbarItem,
    Editing,
    Paging,
    Pager,
    SearchPanel,
    LoadPanel,
    Lookup
} from 'devextreme-react/data-grid';

import Button from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import RadioGroup from 'devextreme-react/radio-group';
import Toast from 'devextreme-react/toast';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { RequiredRule } from 'devextreme-react/cjs/card-view';

const enum MethodSearchType {
    MethodNumber = 1,
    Technology = 2,
    PartNumberAndTechnology = 3
}

const searchTypes = [
    { id: MethodSearchType.MethodNumber, name: "Method#" },
    { id: MethodSearchType.Technology, name: "Technology" },
    { id: MethodSearchType.PartNumberAndTechnology, name: "Part # and Technology" }
];

const methodStateOptions = [
    { id: MethodState.Development, name: 'Development' },
    { id: MethodState.Review, name: 'Review' },
    { id: MethodState.Approved, name: 'Approved' },
];

let key = 0;

export default function MethodsForm() {
    const [searchType, setSearchType] =
        useState<MethodSearchType>(MethodSearchType.MethodNumber);

    const [methods, setMethods] =
        useState<Method[]>();

    const [selectedMethod, setSelectedMethod] =
        useState<Method>();

    const [methodProducts, setMethodProducts] =
        useState<MethodProduct[]>();

    const [technologies, setTechnologies] =
        useState<Technology[]>();

    const [methodNumberSearch, setMethodNumberSearch] =
        useState<string>();

    const [partNumberSearch, setPartNumberSearch] =
        useState<string>();

    const [selectedTechnology, setSelectedTechnology] =
        useState<number>();

    const [addPartToMethodPartNumber, setAddPartToMethodPartNumber] =
        useState<string>();

    const [newMethodPartNumber, setNewMethodPartNumber] =
        useState<string>();

    const [newMethodTechnology, setNewMethodTechnology] =
        useState<number>();

    const [addMethodDialogVisible, setAddMethodDialogVisible] =
        useState<boolean>();

    const [addProductToMethodDialogVisible, setAddProductToMethodDialogVisible] =
        useState<boolean>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [documentLoaderDialogVisible, setDocumentLoaderDialogVisible] =
        useState<boolean>()

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getSelectedMethodProducts();
        setDataLoaded(true);
    }, [selectedMethod]);

    key++;

    return (
        <div className="pw-content">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Methods</div>

                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                        hint="go back"
                        height={'2.6em'}
                        onClick={goBack} />
                </div>
            </div>

            <div className="pw-comp-row">

                <div className="pw-form-unit pw-comp-30">
                    <div className="pw-form-unit-label">Search Type</div>
                    <RadioGroup id="testingLocation" items={searchTypes}
                        displayExpr='name' valueExpr='id' layout="horizontal"
                        value={searchType ? searchType : 1}
                        onValueChanged={(e) => setSearchType(e.value)} />
                </div>

                {searchType === MethodSearchType.MethodNumber &&
                    <div>
                        <div className="pw-form-unit pw-comp-15">
                            <div className="pw-form-unit-label">Method Number</div>
                            <TextBox id="methodNumberSearch" className="textbox"
                                placeholder='Type and hit Enter key'
                                value={methodNumberSearch || undefined}
                                onValueChanged={(e) => setMethodNumberSearch(e.value)}
                                onEnterKey={onSearchMethodsClick}
                                valueChangeEvent="keyup" />
                        </div>
                    </div>
                }

                {searchType === MethodSearchType.PartNumberAndTechnology &&
                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Part Number</div>
                        <TextBox id="partNumberSearch" className="textbox"
                            placeholder='Type and hit Enter key'
                            value={partNumberSearch || undefined}
                            onValueChanged={onPartNumberSearchChanged}
                            onEnterKey={onSearchMethodsClick}
                            valueChangeEvent="keyup" />
                    </div>
                }

                {(searchType === MethodSearchType.PartNumberAndTechnology ||
                    searchType === MethodSearchType.Technology) &&
                    <div className="pw-comp-20">
                        <div className="pw-form-unit-label">Technology</div>
                        <SelectBox id="technologyId" className="selectbox"
                            placeholder='technology'
                            displayExpr='name' valueExpr='technologyId'
                            onValueChanged={onTechnologyChanged}
                            value={selectedTechnology ?
                                selectedTechnology : null}
                            dataSource={technologies ? technologies : []} />
                    </div>
                }

                <div className="pw-row-button-08">
                    <Button className="title-bar-button"
                        text="Search" icon="search" type="success"
                        hint="load methods from database by part number and technology"
                        onClick={onSearchMethodsClick} />
                </div>
            </div>

            <div className="pw-60-40-column-grid pw-margin-top-05">
                <div>
                    <DataGrid
                        height="16rem" width="100%"
                        dataSource={methods ? methods : []}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode='widget'
                        keyExpr="methodId"
                        rowAlternationEnabled={true}
                        showRowLines={true}
                        onSelectionChanged={methodsSelectionChanged}
                        onRowUpdating={handleMethodRowUpdating}
                        showBorders={true}>

                        <LoadPanel enabled={true} />
                        <Paging defaultPageSize={30} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={[30, 60, 100]}
                            showInfo={true} />
                        <Selection mode='single' />
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />

                        <SearchPanel visible={true} />

                        <Column type="buttons" width="8rem">
                            <ColumnButton hint="audit information" icon="clock"
                                onClick={onMethodAuditButtonClicked} />
                            <ColumnButton hint="information" icon="info"
                                onClick={onMethodInformationButtonClicked} />
                            <ColumnButton name="edit" hint="edit row" />
                            <ColumnButton icon="attach" hint="attach document"
                                onClick={onEditDocuments}
                                render={renderDocumentsColumnButton} />
                        </Column>

                        <Column dataField='methodName' caption="Method #" dataType='string' width='8rem' allowEditing={false} />
                        <Column dataField='methodState' caption="Method State"
                            cellRender={renderMethodState} width='8rem' >
                            <Lookup
                                dataSource={methodStateOptions}
                                valueExpr="id"
                                displayExpr="name" />
                            <RequiredRule message="State is required" />
                        </Column>
                        <Column dataField='technologyId' caption="Technology" width='10rem' >
                            <Lookup
                                dataSource={technologies}
                                valueExpr="technologyId"
                                displayExpr="name" />
                            <RequiredRule message="Technology is required" />
                        </Column>
                        <Column dataField='versionNumber' caption="Version #" dataType='string' width='7rem' allowEditing={false} />
                        <Column dataField='createTimestamp' caption="Created" dataType='date' width='8rem' format="MM/dd/yyyy" allowEditing={false} />
                        <Column />

                        <Toolbar>
                            <ToolbarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">Methods</div>
                                </div>
                            </ToolbarItem>
                            <ToolbarItem location='after' name="searchPanel" />

                            {/* KEEP:
                            <ToolbarItem location='after'>
                                <Button type="normal" icon="copy" hint="create a new method based on selected method"
                                    disabled={!selectedMethod}
                                    onClick={onCreateNewMethodBasedOnSelectedMethodClick} />
                            </ToolbarItem>
                            */}

                            <ToolbarItem location='after'>
                                <Button type="normal" icon="plus" hint="create a new method"
                                    onClick={showAddMethodDialog} />
                            </ToolbarItem>
                        </Toolbar>

                        <Editing mode="row"
                            useIcons={true}
                            allowAdding={false}
                            allowUpdating={true}
                            allowDeleting={false} />
                    </DataGrid>
                </div>

                <div className="pw-margin-left-1">
                    <DataGrid
                        height="16rem" width="100%"
                        dataSource={methodProducts ? methodProducts : []}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode='widget'
                        keyExpr="productId"
                        rowAlternationEnabled={true}
                        showRowLines={true}
                        onSelectionChanged={onMethodProductsSelectionChanged}
                        onRowValidating={onMethodProductsRowValidating}
                        onRowRemoving={onMethodProductsDelete}
                        showBorders={true}>

                        <Paging enabled={false} />
                        <Selection mode='single' />
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />

                        <Column type="buttons" width="6rem">
                            <ColumnButton hint="audit information" icon="clock"
                                onClick={onMethodProductAuditButtonClicked} />
                            <ColumnButton hint="information" icon="info"
                                onClick={onMethodProductInformationButtonClicked} />
                            <ColumnButton name="edit" />
                            <ColumnButton name="delete" />
                        </Column>

                        <Column dataField='partNumber' dataType='string' width='10rem' allowEditing={false} />
                        <Column dataField='traceability' dataType='string' />

                        <Toolbar>
                            <ToolbarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">Method Products</div>
                                </div>
                            </ToolbarItem>
                            <ToolbarItem location='after'>
                                <Button type="normal" icon="plus" hint="add a product to the selected method"
                                    disabled={!selectedMethod}
                                    onClick={onAddProductToMethodClick} />
                            </ToolbarItem>
                        </Toolbar>

                        {/* TODO need to implement deleting */}
                        <Editing mode="row"
                            useIcons={true}
                            allowAdding={false}
                            allowUpdating={true}
                            allowDeleting={false} />
                    </DataGrid>

                </div>
            </div>

            <div className="lq-sub-title pw-margin-top-1 pw-margin-bottom-05">Method# {selectedMethod?.methodName || ""} Details</div>

            {/*
            <div className="pw-comp-row pw-margin-bottom-05">
                <div className="pw-comp-10">
                    <div className="pw-form-unit-label">Name</div>
                    <TextBox id="name" placeholder="na" readOnly={true}
                        value={selectedMethod?.methodName || undefined} />
                </div>
            </div>
            */}

            {selectedMethod && selectedMethod.technologyId === BenchSheetTechnologyType.GasChromatography &&
                <GcMethodDetailsComponent methodId={selectedMethod && selectedMethod.methodId ?
                    selectedMethod.methodId : undefined} selectedMethod={selectedMethod}
                    readOnly={false} />
            }

            {selectedMethod && selectedMethod.technologyId === BenchSheetTechnologyType.HighPerformanceLiquidChromatography &&
                <HplcMethodDetailsComponent methodId={selectedMethod && selectedMethod.methodId ?
                    selectedMethod.methodId : undefined} selectedMethod={selectedMethod}
                    readOnly={false} />
            }

            {selectedMethod && selectedMethod.technologyId === BenchSheetTechnologyType.QNuclearMagneticResonance &&
                <QnmrMethodDetailsComponent methodId={selectedMethod && selectedMethod.methodId ?
                    selectedMethod.methodId : undefined} selectedMethod={selectedMethod}
                    readOnly={false} />
            }

            <div className="pw-comp-row-scroll-fixed-grid">
                <NoteViewer height='20rem' title="Method Notes"
                    noteType={NoteType.Method} parentId={selectedMethod && selectedMethod.methodId ?
                        selectedMethod.methodId : undefined} />
            </div>

            <DmaFooter />

            {/*
            {methodSearchByPartNumberDialogVisible &&
                <DialogPopup visible={methodSearchByPartNumberDialogVisible}
                    onHiding={hideMethodSearchByPartNumberDialog}
                    title="Search Methods by Part Number"
                    width='80vw'
                    height='80vh'
                    dragEnabled={false}
                    resizeEnabled={false}>

                    <SearchMethodsComponent
                        onApplySelection={onApplyMethodSearchClick} onCancel={onCancelMethodSearchClick} />

                </DialogPopup>
            }
            */}

            {addMethodDialogVisible &&
                <DialogPopup visible={addMethodDialogVisible}
                    onHiding={hideAddMethodDialog}
                    title="Add New Method"
                    width='30rem'
                    height='20rem'
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <div>
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Technology</div>
                            <SelectBox id="newMethodTechnologyId" className="selectbox"
                                placeholder='technology'
                                displayExpr='name' valueExpr='technologyId'
                                onValueChanged={(e) => setNewMethodTechnology(e.value)}
                                value={newMethodTechnology ?
                                    newMethodTechnology : null}
                                dataSource={technologies ? technologies : []} />
                        </div>

                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Part Number</div>
                            <TextBox id="newMethodPartNumber" className="textbox"
                                onValueChanged={(e) => setNewMethodPartNumber(e.value)}
                                placeholder='part number'
                                value={newMethodPartNumber ? newMethodPartNumber : undefined} />
                        </div>

                        <div className="pw-comp-row">
                            <div className="pw-centered-buttons-container">
                                <Button id="addNewMethodButton"
                                    className="pw-button"
                                    text="Add" type="success"
                                    hint="add method"
                                    height={'2.6em'}
                                    onClick={onAddNewMethodClick} />

                                <Button id="cancelAddNewMethodButton"
                                    className="pw-button"
                                    text="Cancel" type="normal"
                                    hint="cancel"
                                    height={'2.6em'}
                                    onClick={onCancelAddNewMethodClick} />
                            </div>
                        </div>
                    </div>

                </DialogPopup>
            }

            {addProductToMethodDialogVisible &&
                <DialogPopup visible={addProductToMethodDialogVisible}
                    onHiding={hideAddProductToMethodDialog}
                    title="Add Product to Method"
                    width='24rem'
                    height='10rem'
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <div>
                        <div className="pw-form-unit pw-comp-15">
                            <div className="pw-form-unit-label">Part Number</div>
                            <TextBox id="addPartToMethodPartNumber" className="textbox"
                                onValueChanged={(e) => setAddPartToMethodPartNumber(e.value)}
                                placeholder='part number'
                                value={addPartToMethodPartNumber ? addPartToMethodPartNumber : undefined} />
                        </div>

                        <div className="pw-comp-row">
                            <div className="pw-centered-buttons-container">
                                <Button id="addPartNumberToMethodButton"
                                    className="pw-button"
                                    text="Add" type="success"
                                    hint="add part"
                                    height={'2.6em'}
                                    onClick={onAddPartToMethodClick} />

                                <Button id="cancelAddPartNumberToMethodButton"
                                    className="pw-button"
                                    text="Cancel" type="normal"
                                    hint="cancel"
                                    height={'2.6em'}
                                    onClick={onCancelAddPartToMethodClick} />
                            </div>
                        </div>
                    </div>
                </DialogPopup>
            }

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width='25rem'
                    height='21rem'
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {
                documentLoaderDialogVisible &&
                <DialogPopup visible={documentLoaderDialogVisible}
                    onHiding={hideDocumentLoaderDialog}
                    title="Method Documents"
                    width="45rem"
                    height="35rem"
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <DocumentLoader
                        readOnly={false} canDelete={true}
                        parentId={selectedMethod?.methodId || undefined}
                        documentType={DocumentType.Method} />
                </DialogPopup>
            }

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={2000} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    async function onAddNewMethodClick() {
        if (newMethodTechnology) {
            let newMethod: Method = {
                technologyId: newMethodTechnology,
                partNumber: newMethodPartNumber
            };

            await insertMethod(newMethod)
                .then((data) => {
                    if (data && data.value)
                        getNewlyInsertedMethodByMethodId(data.value);

                    hideAddMethodDialog();

                    // Clear search boxes
                    setMethodNumberSearch(undefined);
                    setPartNumberSearch(undefined);
                    setSelectedTechnology(undefined);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Adding Part to Method");
                });
        }
    }

    function onCancelAddNewMethodClick() {
        hideAddMethodDialog();
    }

    async function handleMethodRowUpdating(e) {
        const changedFields = Object.keys(e.newData);
        const rowId = e.key;
        for (const fieldName of changedFields) {
            const payload: FieldUpdate = {
                field: fieldName,
                value: e.newData[fieldName],
                rowId: rowId
            };
            try {
                await CrudFunctions.putData(`methods/methodfield`, payload);
                console.log(`Successfully updated ${fieldName}`);
                showToast("Method updated", "success");
            } catch (error) {
                e.cancel = true;
                showMessage(error, ModalMessageType.Error, "Error Updating Method");
                break;
            }
        }
    }

    async function onAddPartToMethodClick() {
        //console.log("onAddPartToMethodClick");
        // console.log(addPartToMethodPartNumber);

        if (selectedMethod && selectedMethod.methodId && addPartToMethodPartNumber) {
            let methodProduct: MethodProduct = {
                methodId: selectedMethod.methodId,
                partNumber: addPartToMethodPartNumber
            };

            await insertMethodProduct(methodProduct)
                .then(() => {
                    getSelectedMethodProducts();
                    hideAddProductToMethodDialog();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Adding Part to Method");
                });
        }
    }

    function onCancelAddPartToMethodClick() {
        hideAddProductToMethodDialog();
    }

    function onSearchMethodsClick() {
        setMethodProducts(undefined);
        if (searchType === MethodSearchType.MethodNumber) {
            getMethodsByMethodNumber();
        }
        else if (searchType === MethodSearchType.Technology) {
            getMethodsByTechnology();
        }
        else if (searchType === MethodSearchType.PartNumberAndTechnology) {
            getMethodsByPartNumberAndTechnology();
        }
    }

    async function onCreateNewMethodBasedOnSelectedMethodClick() {
        if (selectedMethod && selectedMethod.methodId) {
            await duplicateMethod()
                .then(() => {
                    showToast("Method duplicated", "success");
                    //getMethodsList();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Duplicating Method");
                });
        }
    }

    async function onMethodProductsRowValidating(e: any) {
        if (e.oldData) {
            let methodProduct = e.oldData as MethodProduct;

            if (methodProduct) {
                let updatedMethodProduct = { ...methodProduct, ...e.newData };

                await updateMethodProduct(updatedMethodProduct)
                    .then(() => {
                        showToast("Method Product updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Method Product");
                    });
            }
        }
    }


    /*
    async function onApplyMethodSearchClick(methodSearch: MethodSearch) {
        console.log(methodSearch);

        if (methodSearch) {
            let data = await getMethodByMethodId(methodSearch.methodId);

            let matchingMethod = data as Method;

            if (matchingMethod) {
                setSelectedTechnology(matchingMethod.technologyId);
                setSelectedMethod(matchingMethod);

                let newMethods: Method[] = [];
                newMethods.push(matchingMethod);

                setMethods(newMethods);
            }
        }

        hideMethodSearchByCatalogNumberDialog();
    }

    function onCancelMethodSearchClick() {
        hideMethodSearchByCatalogNumberDialog();
    }
    */

    function onPartNumberSearchChanged(e: any) {
        setPartNumberSearch(e.value);
    }

    function onTechnologyChanged(e: any) {
        setSelectedTechnology(e.value);
    }

    function methodsSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            if (e.selectedRowsData[0].methodId)
                getMethod(e.selectedRowsData[0].methodId);
        }
    }

    function onMethodProductsSelectionChanged(e: any) {

    }

    function onMethodProductsDelete(e: any) {

    }

    function onMethodProductAuditButtonClicked(e: any) {

    }

    function onMethodProductInformationButtonClicked(e: any) {

    }

    function onMethodProductDeleteClick(e: any) {

    }

    function onAddProductToMethodClick() {
        showAddProductToMethodDialog();
    }

    /*
    async function onMethodsValidating(e: any) {
        if (!dataLoaded)
            return;

        if (e.newData) {
            let method = e.newData as Method;
            //method.methodId = e.key; //generated GUID

            await insertMethod(method)
                .then(() => {
                    showToast("Method saved", "success");
                    getMethodsList();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Inserting Method");
                });
        }
    }
    */

    async function onMethodDelete(e: any) {
        if (e.data && e.data.methodId) {
            await deleteMethod(e.data.methodId)
                .then(() => {
                    showToast("Method Deleted Successfully", "success");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Method");
                });
        }
    }

    function onEditDocuments(e: any) {
        if (e.row && e.row.data)
            setSelectedMethod(e.row.data);

        showDocumentLoaderDialog();
    }

    function showDocumentLoaderDialog() {
        setDocumentLoaderDialogVisible(true);
    }

    function hideDocumentLoaderDialog() {
        setDocumentLoaderDialogVisible(false);
    }

    async function getMethod(methodId: string) {
        setDataLoaded(false);

        await CrudFunctions.getData(`methods/method/${methodId}`)
            .then(data => {
                setSelectedMethod(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Method Data");
            });
    }

    async function getSelectedMethodProducts() {
        if (selectedMethod && selectedMethod.methodId) {
            await CrudFunctions.getData(`methods/methodproducts/${selectedMethod.methodId}`)
                .then(data => {
                    setMethodProducts(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Method Products");
                });
        }
    }

    async function getNewlyInsertedMethodByMethodId(methodId: string) {
        await CrudFunctions.getData(`methods/method/${methodId}`)
            .then(data => {
                //console.log("RETURNED: getMethodByMethodId():")
                // console.log(data);

                if (data) {
                    let newMethodsList: Method[] = [];
                    newMethodsList.push(data);

                    setMethods(newMethodsList);
                    setSelectedMethod(data);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Unable to Retrieve New Method");
            });
    }

    async function getMethodsByTechnology() {
        if (selectedTechnology) {
            await CrudFunctions.getData(`methods/methodsbysearch/tech/${selectedTechnology}`)
                .then(data => {
                    setMethods(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Methods");
                });
        }
    }

    async function getMethodsByPartNumberAndTechnology() {
        if (partNumberSearch && selectedTechnology) {
            await CrudFunctions.getData(`methods/methodsbysearch/${selectedTechnology}/${partNumberSearch}`)
                .then(data => {
                    setMethods(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Methods");
                });
        }
    }

    async function getMethodsByMethodNumber() {
        if (methodNumberSearch) {
            // Reformat search string to integer (strip leading numbers and zeroes)
            const regexForDigitsMatch = methodNumberSearch.match(/[1-9].*/);
            if (!regexForDigitsMatch) {
                showToast("Enter at least one non-zero digit", "warning");
                return;
            }
            const methodNumberInt = parseInt(regexForDigitsMatch[0], 10);
            await CrudFunctions.getData(`methods/methods/${methodNumberInt}`)
                .then(data => {
                    setMethods(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Methods");
                });
        }
    }

    async function getTechnologies() {
        await CrudFunctions.getData("common/benchsheettechnologytypes")
            .then(data => {
                setTechnologies(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Technology List");
            });
    }

    //todo FIX URL
    async function duplicateMethod() {
        return await CrudFunctions.postData(`methods/duplicatemethod/${selectedMethod.methodId}`, null);
    }

    async function insertMethod(newMethod: Method) {
        return await CrudFunctions.postData("methods/method", newMethod);
    }

    async function insertMethodProduct(methodProduct: MethodProduct) {
        return await CrudFunctions.postData("methods/methodproduct", methodProduct);
    }

    async function updateMethodProduct(methodProduct: MethodProduct) {
        return await CrudFunctions.putData("methods/methodproduct", methodProduct);
    }

    async function deleteMethod(methodId: string) {
        return await CrudFunctions.deleteData(`methods/method/${methodId}`);
    }

    async function getAllData() {
        await Promise.all([
            getTechnologies()
        ])
            .then(() => setDataLoaded(true));
    }

    //render

    function renderMethodState(cellData: any) {
        let css = "pw-green";
        const currentMethodStateId = cellData.value;
        const label = cellData.displayValue;
        if (currentMethodStateId === MethodState.Development)
            css = "pw-red";
        else if (currentMethodStateId === MethodState.Review)
            css = "pw-orange";
        return <div className={css}>{label}</div>;
    }

    function renderDocumentsColumnButton(e: any) {
        if (e.data && e.data.documentCount > 0)
            return <><i className="dx-icon-attach pw-green cursor-pointer"></i><span className="pw-green pw-normal">{e.data.documentCount}</span></>;
        return <i className="dx-icon-attach cursor-pointer"></i>;
    }

    //navigation

    function goBack() {
        history.back();
    }

    function onMethodAuditButtonClicked(e: any) {

    }

    function onMethodInformationButtonClicked(e: any) {
        if (e.row && e.row.data) {
            const method = e.row.data as Method;

            if (method) {
                setSelectedMethod(method);

                let itemInformation: ItemBasicInformation = {
                    rowPointer: method.methodId,
                    createTimestamp: method.createTimestamp,
                    lastModifiedTimestamp: method.modifyTimestamp,
                    createUser: method.createUser,
                    modifyUser: method.modifyUser
                };

                setItemBasicInformation(itemInformation);
                setItemBasicInformationDialogVisible(true);
            }
        }
    }

    /*
    function showMethodSearchByPartNumberDialog() {
        setMethodSearchByPartNumberDialogVisible(true);
    }

    function hideMethodSearchByPartNumberDialog() {
        setMethodSearchByPartNumberDialogVisible(false);
    }
    */

    function showAddMethodDialog() {
        setAddMethodDialogVisible(true);
    }

    function hideAddMethodDialog() {
        setAddMethodDialogVisible(false);
    }

    function showAddProductToMethodDialog() {
        setAddProductToMethodDialogVisible(true);
    }

    function hideAddProductToMethodDialog() {
        setAddProductToMethodDialogVisible(false);
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}